import Keycloak from 'keycloak-js';

export const PATRIMONUS_WEB_URL = 'https://www.patrimonus.oups.net';
export const PATRIMONUS_API_URL = 'https://api.patrimonus.oups.net';
export const AUTH_CALLBACK_URL = `${PATRIMONUS_WEB_URL}/auth/callback`;

const keycloak = new Keycloak({
	url: 'https://auth.oups.net',
	realm: 'patrimonus',
	clientId: 'patrimonus-web'
});

export async function initializeAuthentication() {
	const authenticated = await keycloak.init({
		flow: 'standard',
		pkceMethod: 'S256',
		responseMode: 'fragment',
		checkLoginIframe: false,
		redirectUri: AUTH_CALLBACK_URL,
		scope: 'patrimonus:access'
	});

	if (window.location.pathname === '/auth/callback') {
		window.history.replaceState({}, document.title, '/');
	}

	keycloak.onTokenExpired = () => {
		keycloak.updateToken(30).catch(() => login());
	};

	return {
		authenticated,
		username: keycloak.tokenParsed?.preferred_username ?? null,
		roles: keycloak.realmAccess?.roles ?? []
	};
}

export function login() {
	return keycloak.login({ redirectUri: AUTH_CALLBACK_URL });
}

export function register() {
	return keycloak.register({ redirectUri: AUTH_CALLBACK_URL });
}

export function logout() {
	return keycloak.logout({ redirectUri: `${PATRIMONUS_WEB_URL}/` });
}

export function clearAuthentication() {
	keycloak.clearToken();
}

export async function accessToken() {
	if (!keycloak.authenticated) {
		throw new Error('Authentication is required');
	}

	await keycloak.updateToken(30);
	return keycloak.token;
}
